import React from 'react';
import { formatWithCommas } from '../../../func/helper';
import { attachSeries } from '../../../utils/product';

const InfoCaption = ({ id, price, weight, wage, sold, discount, series, lg }) => {
  discount = parseInt(discount, 10);
  sold = parseInt(sold, 10);
  const refTag = React.useRef();
  const [state, setState] = React.useState({ copied: false });

  const handleCopy = () => {
    let text = 'کد : ' + id;
    text += '\n' + 'قیمت : ' + formatWithCommas(price) + ' R';
    text += '\n' + 'وزن : ' + weight;
    if (discount > 0) {
      text += '\n' + 'اجرت فقط : ' + wage;
      text += '\n' + 'تخفیف : ' + formatWithCommas(discount);
    }

    navigator.clipboard.writeText(text).then(() => {
      setState({ copied: true });

      setTimeout(() => {
        setState({ copied: false });
      }, 1500);
    });
  };

  if (sold === 1) {
    return (
      <div className={'info-caption sold' + (lg ? ' lg' : '')}>
        {state.copied && <div className={'copied'}>کپی شد</div>}
        <div className={'column'}>
          <div className={'sold'}>فروخته شد</div>
          <div className={'value'}>{attachSeries(id, series)}</div>
        </div>
      </div>
    );
  } else {
    return (
      <>
        <div className={'info-caption' + (lg ? ' lg' : '')} onClick={handleCopy} ref={refTag}>
          {state.copied && <div className={'copied'}>کپی شد</div>}
          <div className={'column'}>
            <div className={'value'}>
              {attachSeries(id, series)}
              {discount <= 0 && (wage ? `-${wage}` : '')}
            </div>
            {discount > 0 && <div className={'value'}>فقط {wage}</div>}
            <div className={'value'} style={discount ? { textDecoration: 'line-through' } : {}}>
              {formatWithCommas(price)}R
            </div>
            {discount > 0 && (
              <div
                className={'value'}
                style={{
                  color: '#fff',
                  backgroundColor: '#CC4337',
                  borderRadius: '4px',
                  paddingRight: '2px',
                  paddingLeft: '2px',
                }}
              >
                {formatWithCommas(discount)}R
              </div>
            )}
            <div className={'value'}>{weight}g</div>
          </div>
          <div className={'column'}>
            <div className={'key'}>کد</div>
            {discount > 0 && <div className={'key'}>اجرت</div>}
            <div className={'key'}>قیمت</div>
            {discount > 0 && <div className={'key'}>تخفیف</div>}
            <div className={'key'}>وزن</div>
          </div>
        </div>
      </>
    );
  }
};

export default InfoCaption;
